// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CustomersSection_cardContainer__A8F_D","cardBox":"CustomersSection_cardBox__UeLfw"};